module.exports = __webpack_public_path__ + "static/media/bg_9_and_10_sky.c6884899.jpg";